import nProgress from 'nprogress';
import 'nprogress/nprogress.css';

let nRequests = 0;

export default {
  start() {
    if (nRequests === 0) {
      nProgress.start();
    }
    nRequests += 1;
  },
  done() {
    nRequests -= 1;
    if (nRequests === 0) {
      nProgress.done();
    } else {
      nProgress.inc();
    }
  },
  forceFinish() {
    nRequests = 0;
    nProgress.done();
  }
};